/**
 * Base class for all rules.
 */
class Rule {
  type;
  config;
  log = [];
  meta = {};
  #guid;
  initialized = false;

  dependencies = {
    evaluate: [],
    hydrateMeta: []
  }

  comparatorFunctions = {
    "gte": (a, b) => a >= b,
    "gt" : (a, b) => a > b,
    "lte": (a, b) => a <= b,
    "lt" : (a, b) => a < b,
    "eq" : (a, b) => a == b,
    "neq": (a, b) => a != b
  }

  constructor(config = {}) {
    this.config = config;
  }

  get guid() {
    return this.#guid;
  }

  set guid(value) {
    this.#guid = value;
  }

  async initialize() {
    if (this.initialized) return;
    try {
      await this.hydrateMeta();
      this.initialized = true;
    } catch (e) {
      console.error(this.logPrefix, 'Failed to hydrate meta -', e.message);
    }
  }

  checkDependencies(type) {
    let missingDependencies = this.dependencies[type].filter(helper => !Stencil.Helpers[helper]);
    if (missingDependencies.length > 0) {
      throw new Error(`Missing required dependencies for '${type}': ${missingDependencies.join(', ')}`);
    }
  }
  
  evaluate(data) {
    this.checkDependencies("evaluate");
  }

  explain() {
    console.log(`Explainining rule ${this.type}`);
  }

  hydrateMeta() {
    this.checkDependencies("hydrateMeta");
  }

  addLog(result = true, target, actual, comparator = "") {
    this.log.push({ time: Date.now(), type: this.type, result: result ? "✅" : "❌", target, actual, comparator });
  }

  get logPrefix() {
    return `\x1b[30;44;1m[Rule/${this.type}]`;
  }
}

export default Rule;